<template>
	<div class="product-page">

		<div style="max-width: 100%;padding-top: 20px;">
			<!-- 购物车区域 -->
			<div class="container">
				<div class="section-header">
					<div class="section-divider"></div>
					<h3>{{ $t('cart') }}</h3>
				</div>
				<div class="cart-info">
					<div class="match-table">
						<!-- 表格头部 -->
						<div class="table-header">
							<div class="checkbox-col">
								<el-checkbox v-model="selectAll"></el-checkbox>
								<span style="padding-left: 5px;">{{ $t('selectAll') }}</span>
							</div>
							<div class="product-info-col">{{ $t('productInfo') }}</div>
							<div class="quantity-col">{{ $t('productQuantity') }}</div>
							<div class="price-col">{{ $t('unitPrice') }}</div>
							<div class="total-col">{{ $t('totalPrice') }}</div>
						</div>

						<!-- 店铺列表 -->
						<div v-for="(store, storeIndex) in stores" :key="storeIndex" style="border-radius: 10px;">
							<!-- 店铺间隔 -->
							<div v-if="storeIndex > 0" class="store-separator"></div>

							<!-- 店铺头部 -->
							<div class="store-header">
								<div class="checkbox-col checkbox-store-col">
									<el-checkbox v-model="store.selected"></el-checkbox>
									<div class="product-info-col store-product-info">
										<div class="vip-tag">
											<img src="/icon/common/vip.svg" style="width: 15px;">
											VIP{{ store.vipLevel }}
										</div>
										<span class="store-name">{{ store.name }}</span>
									</div>
								</div>
								<div class="total-col" style="text-align: right">
									<el-button type="primary" plain size="mini" class="customer-service-btn"
										icon="el-icon-s-custom">{{ $t('merchantCustomerService') }}</el-button>
								</div>
							</div>

							<!-- 商品列表 -->
							<div v-for="(product, productIndex) in store.products" :key="productIndex"
								style="border-radius: 0 0 8px 8px;">
								<!-- 商品名称行 -->
								<div class="product-name-row">
									<div class="checkbox-col checkbox-image-col">
										<el-checkbox v-model="product.selected"></el-checkbox>
										<img :src="product.image" alt="Product Image" class="product-image">
									</div>
									<div class="product-info-col" style="width: 90%;">
										<div class="product-main">
											<div class="product-name">{{ product.name }}</div>
										</div>

										<!-- SKU列表 -->
										<div v-for="(sku, skuIndex) in product.skus" :key="skuIndex" class="sku-row">
											<div class="product-info-col" style="width: 34%;padding-left: 0;">
												<el-checkbox v-model="sku.selected"></el-checkbox>
												<img :src="sku.image" alt="SKU Image" class="sku-image">
												<span class="sku-style">{{ sku.style }}</span>
											</div>
											<div class="quantity-col" style="width: 22%;">
												<el-input-number v-model="sku.quantity" :min="1" :max="999"
													size="mini"></el-input-number>
												<i class="el-icon-delete"
													style="color: #D9001B;margin-left: 15px;cursor: pointer;"></i>
											</div>
											<div class="price-col price-col-item">
												<span class="sku-price">${{ sku.price.toFixed(2) }}</span>
											</div>
											<div class="total-col total-col-item">
												<span class="sku-total">
													${{ (sku.quantity * sku.price).toFixed(2) }}</span>
											</div>
										</div>
									</div>
								</div>
								<!-- 操作按钮行 -->
								<div class="action-row" style="border-radius: 0 0 8px 8px;">
									<div
										style="display: flex;align-items: center;justify-content: space-between;width: 90%;">
										<el-button type="primary" size="small"
											class="add-sku-btn">{{ $t('addSKU') }}</el-button>
										<div class="action-buttons">
											<el-button type="default" size="mini" class="save-item-btn">
												<i class="el-icon-star-on"></i>
												{{ $t('saveItem') }}
											</el-button>
											<el-button type="warning" plain size="small"
												class="look-similar-btn">{{ $t('lookForSimilar') }}</el-button>
											<el-button type="danger" plain size="small"
												class="delete-spu-btn">{{ $t('deleteSPU') }}</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 操作按钮区域 -->
			<div class="submit-layout" :class="{'submit-layout-fixed':!isSubmitSticky}">
				<div class="submit-left">
					<el-checkbox v-model="selectAll" @change="handleSelectAll">{{ $t('selectAll') }}</el-checkbox>
					<el-button type="danger" plain size="mini" class="delete-all-btn">{{ $t('delete') }}</el-button>
				</div>
				<div class="submit-center">
					<div>
						<span>{{ $t('purchasingPlatform') }}</span>
						<el-select :placeholder="$t('selectPlaceholder')" class="center-select">
							<el-option :label="$t('clothing')" value="clothing"></el-option>
							<el-option :label="$t('bags')" value="bags"></el-option>
							<el-option :label="$t('shoes')" value="shoes"></el-option>
						</el-select>
					</div>
					<div>
						<span>{{ $t('sellerCount') }}</span>
						<span class="center-num">0/20</span>
					</div>
				</div>
				<div class="submit-right">
					<div class="submit-sub-right">
						<span class="right-text">{{ $t('selectedItems') }}
							<span class="text-span">{{ selectedCount }}/12</span>{{$t('unit')}}SKU（<span
								class="text-span">0</span>{{$t('unitPiece')}}）
							{{ $t('items') }}</span>
						<el-button type="primary" class="custom-btn">{{ $t('goToBuy') }}</el-button>
					</div>
				</div>
			</div>

			<!-- 无法购买区域 -->
			<div class="container">
				<div class="section-header">
					<div class="section-divider"></div>
					<h3>{{ $t('unavailableProducts') }}</h3>
				</div>

				<div class="cart-not-buy">
					<div v-for="(item, index) in (showAllUnavailable ? unavailableProducts : unavailableProducts.slice(0, 3))"
						:key="item.id" class="unavailable-item">
						<div class="store-info">
							<div class="vip-tag">
								<img src="/icon/common/vip.svg" style="width: 15px;">
								VIP{{ item.store.vipLevel }}
							</div>
							<span class="store-name">{{ item.store.name }}</span>
							<el-button type="primary" plain size="mini" class="customer-service-btn"
								icon="el-icon-s-custom">{{ $t('merchantCustomerService') }}</el-button>
						</div>
						<div class="product-info" v-for="(good, index) in item.products" :key="good.id"
							:class="{'product-info-last': index === item.products.length - 1}">
							<img :src="good.image" alt="Product Image" class="product-image">
							<div class="product-details">
								<div class="product-name">{{ good.name }}</div>
								<div class="product-remark">
									<span>{{ good.status }}</span>
									<div class="action-buttons">
										<el-button type="warning" plain size="small"
											class="look-similar-btn">{{ $t('lookForSimilar') }}</el-button>
										<i class="el-icon-delete"
											style="color: #D9001B;font-size: 18px;cursor: pointer;margin-left: 5px;"></i>
									</div>
								</div>
							</div>
						</div>

					</div>
					<div v-if="unavailableProducts.length > 3 && !showAllUnavailable" class="show-all-btn">
						<el-button type="text" @click="showAllUnavailable = true"
							style="color: #1890ff;font-size: 16px;">{{$t('expandall')}}</el-button>
					</div>
				</div>
			</div>

			<div class="container" style="height: 30px;">&nbsp;</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Cart',
		data() {
			return {
				selectAll: false,
				isSubmitSticky: true,
				showAllUnavailable: false,
				unavailableProducts: [{
						id: 1,
						store: {
							name: 'Lingling Self operated Factory - Store 3667',
							vipLevel: 1
						},
						products: [{
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}, {
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}]
					},
					{
						id: 2,
						store: {
							name: 'Lingling Self operated Factory - Store 3667',
							vipLevel: 1
						},
						products: [{
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}, {
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}]
					},
					{
						id: 3,
						store: {
							name: 'Lingling Self operated Factory - Store 3667',
							vipLevel: 1
						},
						products: [{
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}, {
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}]
					},
					{
						id: 4,
						store: {
							name: 'Lingling Self operated Factory - Store 3667',
							vipLevel: 1
						},
						products: [{
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}, {
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}]
					},
					{
						id: 5,
						store: {
							name: 'Lingling Self operated Factory - Store 3667',
							vipLevel: 1
						},
						products: [{
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}, {
							image: '/img/p8.png',
							name: 'CAMEL Camel Capsule Series Maimakesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
							status: '您所选的商品因缺货、下架、无对应SKU的原因已无法进行购买',
						}]
					}
				],
				// 店铺商品数据
				stores: [{
					id: 1,
					name: 'Lingling Self operated Factory - Store 3667',
					vipLevel: 1,
					selected: false,
					products: [{
						id: 1,
						name: 'CAMEL Camel Capsule Series Maimaikesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
						image: '/img/p8.png',
						selected: false,
						skus: [{
							id: 1,
							image: '/img/p9.png',
							style: 'Style: Black (with added velvet); Size: S',
							quantity: 1,
							price: 132,
							selected: false
						}, {
							id: 2,
							image: '/img/p8.png',
							style: 'Style: Black (with added velvet); Size: M',
							quantity: 2,
							price: 132,
							selected: false
						}, {
							id: 3,
							image: '/img/p10.png',
							style: 'Style: Grey (with added velvet); Size: S',
							quantity: 2,
							price: 132,
							selected: false
						}, {
							id: 4,
							image: '/img/p11.png',
							style: 'Style: Grey (with added velvet); Size: M',
							quantity: 2,
							price: 132,
							selected: false
						}]
					}]
				}, {
					id: 2,
					name: 'Lingling Self operated Factory - Store 3668',
					vipLevel: 1,
					selected: false,
					products: [{
						id: 3,
						name: 'CAMEL Camel Capsule Series Maimaikesong Casual Stand up Collar Short, High Fluffy and Thick Outdoor Windproof and Cold proof Warm Bread Autumn...',
						image: '/img/p8.png',
						selected: false,
						skus: [{
							id: 1,
							image: '/img/p9.png',
							style: 'Style: Black (with added velvet); Size: S',
							quantity: 1,
							price: 132,
							selected: false
						}, {
							id: 2,
							image: '/img/p8.png',
							style: 'Style: Black (with added velvet); Size: M',
							quantity: 2,
							price: 132,
							selected: false
						}, {
							id: 3,
							image: '/img/p10.png',
							style: 'Style: Grey (with added velvet); Size: S',
							quantity: 2,
							price: 132,
							selected: false
						}, {
							id: 4,
							image: '/img/p11.png',
							style: 'Style: Grey (with added velvet); Size: M',
							quantity: 2,
							price: 132,
							selected: false
						}]
					}]
				}]
			}
		},
		computed: {

			// 计算选中的SKU数量
			selectedCount() {
				let count = 0;
				this.stores.forEach(store => {
					store.products.forEach(product => {
						product.skus.forEach(sku => {
							if (sku.selected) {
								count++;
							}
						});
					});
				});
				return count;
			},

		},
		mounted() {
			// 添加滚动事件监听
			window.addEventListener('scroll', this.handleScroll);
			// 在组件销毁时移除事件监听
			this.$once('hook:destroyed', () => {
				window.removeEventListener('scroll', this.handleScroll);
			});
			// 初始检查定位状态
			this.$nextTick(() => {
				// 初始化时强制设置为悬浮状态
				this.isSubmitSticky = true;
				// 延迟执行滚动检查，确保页面元素完全加载
				setTimeout(() => {
					this.handleScroll();
				}, 100);
			});
		},
		methods: {

			handleScroll() {
				const matchTable = document.querySelector('.match-table');

				if (matchTable) {
					// 获取元素位置信息
					const tableRect = matchTable.getBoundingClientRect();

					// 检查match-table是否完全在视口内
					// 如果表格的高度加上顶部位置小于等于页面高度，说明表格完全可见
					const isTableFullyVisible = (tableRect.height + tableRect.top) <= window.innerHeight;

					// 设置sticky定位状态：
					// - 当表格不完全可见时，submit-layout悬浮在底部
					// - 当表格完全可见时，submit-layout正常显示在表格下方
					this.isSubmitSticky = !isTableFullyVisible;
				}
			},
			handleSelectAll(val) {
				// 更新所有店铺的选中状态
				this.stores.forEach(store => {
					store.selected = val;
					// 更新店铺下所有商品的选中状态
					store.products.forEach(product => {
						product.selected = val;
						// 更新商品下所有SKU的选中状态
						product.skus.forEach(sku => {
							sku.selected = val;
						});
					});
				});
			}
		}
	}
</script>

<style scoped>
	.custom-btn {
		padding: 15px 25px;
		font-size: 16px;
		min-width: 160px;
		margin-left: 10px;
	}

	.delete-all-btn {
		background-color: #D9001B;
		border-color: #D9001B;
		margin-left: 10px;
	}

	.product-page {
		padding: 0;
		background: #F2F2F2;
	}

	.container {
		max-width: 1200px;
		margin: 0 auto;
	}

	.cart-info {
		margin-bottom: 20px;
	}

	/* Cart Info Styles */
	.match-table {
		margin-top: 20px;
		width: 100%;
		border-radius: 8px;
		overflow: hidden;
		min-height: 200px;
	}

	/* 表格头部 */
	.table-header {
		background-color: #fff;
		font-weight: bold;
		color: #333;
		font-size: 14px;
		display: flex;
		border-bottom: 1px solid #e8e8e8;
	}

	/* 表格行 */
	.table-header,
	.product-name-row,
	.sku-row,
	.store-header,
	.action-row {
		display: flex;
	}

	/* 表格单元格 */
	.table-header>div,
	.product-name-row>div,
	.sku-row>div,
	.store-header>div,
	.action-row>div {
		padding: 12px 16px;
		text-align: center;
		box-sizing: border-box;
	}

	/* 最后一列无边框 */
	.table-header>div:last-child,
	.product-name-row>div:last-child,
	.sku-row>div:last-child,
	.store-header>div:last-child,
	.action-row>div:last-child {
		border-right: none;
	}

	/* 列宽设置 */
	.checkbox-col {
		text-align: left !important;
		width: 10%;
		padding: 12px 16px 12px 24px;
	}

	.checkbox-store-col {
		width: 80%;
		display: flex;
		align-items: center;
	}

	.checkbox-image-col {
		display: flex;
	}

	.product-info-col {
		width: 30%;
		padding: 12px 24px;
	}

	.store-product-info {
		width: 100%;
		display: flex;
		padding: 0;
		margin-left: 10px;
	}

	.quantity-col {
		width: 20%;
		padding: 12px 24px;
		text-align: center;
	}

	.price-col {
		width: 20%;
		padding: 12px 24px;
		text-align: center;
	}

	.price-col-item {
		width: 22%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #666;
		font-size: 13px;
		font-weight: bold;
	}

	.total-col {
		width: 20%;
		padding: 12px 24px;
		text-align: center;
		font-weight: bold;
	}

	.total-col-item {
		width: 22%;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #F59A23;
		font-size: 18px;
		font-weight: bold;
		padding-right: 0 !important;
	}

	/* 店铺间隔 */
	.store-separator {
		height: 20px;
		background-color: #f2f2f2;
	}

	/* 店铺头部 */
	.store-header {
		background-color: #fff;
	}

	.vip-tag {
		background-color: #FEF5E9;
		color: #F59A23;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: bold;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		margin-right: 8px;
	}

	.store-name {
		font-size: 14px;
		font-weight: bold;
		color: #333;
	}

	.customer-service-btn {
		background-color: #e6f7ff;
		border-color: #91d5ff;
		color: #1890ff;
		font-size: 12px;
	}

	/* 商品名称行 */
	.product-name-row {
		background-color: #fff;
	}

	.product-main {
		display: flex;
		align-items: center;
	}

	.product-image {
		width: 80px;
		height: 80px;
		object-fit: cover;
		border-radius: 4px;
		margin: 0 10px;
		border: 1px solid #f2f2f2;
		border-radius: 5px;
	}

	.product-name {
		font-size: 14px;
		font-weight: bold;
		color: #333;
		line-height: 1.4;
		flex: 1;
	}

	/* SKU行 */
	.sku-row {
		background-color: #fff;
	}

	.sku-row .product-info-col {
		display: flex;
		align-items: center;
	}

	.sku-image {
		width: 32px;
		height: 32px;
		object-fit: cover;
		border: 1px solid #e8e8e8;
		border-radius: 2px;
		margin: 0 10px;
	}

	.sku-style {
		font-size: 13px;
		color: #666;
	}

	/* 操作按钮行 */
	.action-row {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		background-color: #fff;
		padding: 0;
	}

	.action-buttons {
		display: flex;
		align-items: center;
		gap: 8px;
		justify-content: flex-end;
	}

	.add-sku-btn {
		background-color: #1890ff;
		border-color: #1890ff;
		color: white;
		font-size: 14px;
	}

	.save-item-btn {
		color: #999;
		font-size: 12px;
	}

	.save-item-btn:hover {
		color: #F59A23;
	}

	.look-similar-btn {
		font-size: 14px;
	}

	.delete-spu-btn {
		background-color: #D9001B;
		border-color: #D9001B;
		color: white;
		font-size: 14px;
	}

	/* 数量输入 */
	.quantity-col :deep .el-input-number {
		width: 100px;
		margin: 0 auto;
	}

	/* Submit Layout Styles */
	.submit-layout {
		box-shadow: 1px 1px 10px #ccc;
		background-color: white;
		padding: 15px 200px;
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 15px;
		position: sticky;
		bottom: 0;
		max-width: 100%;
		z-index: 9;
	}

	.submit-layout-fixed {
		/* 移除悬浮效果，使用正常文档流定位 */
		position: static !important;
		bottom: auto !important;
		/* 保持原有样式但移除阴影 */
		box-shadow: none;
		/* 调整内边距以适应容器 */
		padding: 15px 20px;
		/* 调整最大宽度以适应内容区域 */
		max-width: 1200px;
		/* 调整外边距 */
		margin: 0 auto 20px auto;
		/* 确保z-index不会影响其他元素 */
		z-index: auto !important;
	}

	.submit-left {
		flex: 1;
		max-width: 300px;
	}

	.submit-center {
		font-size: 14px;
		color: #606266;
		display: flex;
		align-items: center;
	}

	.center-select {
		width: 150px;
		margin: 0 20px 0 10px;
	}

	.center-num {
		font-size: 17px;
		font-weight: bold;
		padding-left: 10px;
	}

	.submit-right {
		flex: 1;
		min-width: 250px;
		display: flex;
		justify-content: flex-end;
		gap: 15px;
		color: #606266;
	}

	/* 无法购买商品样式 */
	.cart-not-buy {
		margin-top: 20px;
	}

	.unavailable-item {
		background-color: #fff;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 12px;
	}

	.store-info {
		display: flex;
		align-items: center;
		gap: 8px;
		margin-bottom: 12px;
	}

	.store-info .vip-tag {
		background-color: #FEF5E9;
		color: #F59A23;
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: bold;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	.store-info .store-name {
		font-size: 14px;
		font-weight: bold;
		color: #333;
		flex: 1;
	}

	.store-info .customer-service-btn {
		background-color: #e6f7ff;
		border-color: #91d5ff;
		color: #1890ff;
		font-size: 12px;
	}

	.product-info {
		display: flex;
		align-items: flex-start;
		gap: 12px;
		margin-bottom: 12px;
		padding-bottom: 12px;
		border-bottom: 1px solid #f2f2f2;
	}

	.product-info-last {
		border-bottom: none;
		margin-bottom: 0;
		padding-bottom: 0;
	}

	.product-info .product-image {
		width: 80px;
		height: 80px;
		object-fit: cover;
		border-radius: 4px;
		flex-shrink: 0;
	}

	.product-remark {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #999;
		justify-content: space-between;
		margin-top: 20px;
	}

	.action-buttons {
		display: flex;
		justify-content: flex-end;
		gap: 8px;
	}

	.look-similar-btn {
		background-color: #fff;
		border-color: #f59a23;
		color: #f59a23;
		font-size: 12px;
	}

	.delete-btn {
		background-color: #fff;
		border-color: #d9001b;
		color: #d9001b;
		font-size: 12px;
		width: 32px;
		height: 32px;
		padding: 0;
	}

	.show-all-btn {
		text-align: center;
		margin-top: -110px;
		height: 120px;
		background: linear-gradient(to bottom, rgba(255, 255, 255, 0.3), #F2F2F2);
		position: relative;
		z-index: 999;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.submit-sub-right {
		display: flex;
		align-items: center;
	}

	.right-text {
		font-size: 14px;
	}

	.text-span {
		font-size: 17px;
		font-weight: bold;
		color: #D9001B;
	}

	.section-header h3 {
		margin: 0;
		font-size: 16px;
		font-weight: bold;
		color: #333;
	}

	:deep .el-input-number--mini {
		width: 100px;
	}
</style>